import React from "react";
import RealTimeUpdates from "../../assets/images/Data-enrichment/real-time-updates.png";
import EnhancedLeadProfiles from "../../assets/images/Data-enrichment/enhanced-lead-profiles.png";
import ImprovedTargeting from "../../assets/images/Data-enrichment/improved-tragetting.png";
import IncreasedAccuracy from "../../assets/images/Data-enrichment/increased-accuracy.png";
import SeamlessIntegration from "../../assets/images/Data-enrichment/seamless-integration.png";

const FeatureGrid = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Header */}
        <div className="tw-text-center tw-mb-16">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Your Target, Our Precision
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Supercharge Campaigns with <span className="tw-text-[#5D44FF]">Data Enrichment</span>
          </h2>
        </div>

        {/* Row 1: Real-Time Updates (smaller width) & Enhanced Lead Profiles (larger width) */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[430px_1fr] tw-gap-8 tw-mb-8">
          
          {/* Card 1: Real-Time Updates */}
          <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col">
            <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
              Real-Time Updates
            </h3>
            <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-mb-6 tw-flex-grow">
              Keep your data fresh and relevant with real-time updates from trusted third-party data providers.
            </p>
            <div className="tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-mt-auto">
              <img
                src={RealTimeUpdates}
                alt="Real-Time Updates"
                className="tw-max-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                loading="lazy"
              />
            </div>
          </div>

          {/* Card 2: Enhanced Lead Profiles */}
          <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col">
            <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
              Enhanced Lead Profiles
            </h3>
            <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-mb-6 tw-flex-grow">
              Automatically enrich your lead data with additional information, such as job titles, company size, industry, and more, giving you a fuller picture of your potential customers.
            </p>
            <div className="tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-mt-auto">
              <img
                src={EnhancedLeadProfiles}
                alt="Enhanced Lead Profiles"
                className="tw-max-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                loading="lazy"
              />
            </div>
          </div>

        </div>

        {/* Row 2: Improved Targeting (larger width) & Increased Accuracy (smaller width) */}
        <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[1fr_430px] tw-gap-8 tw-mb-8">
          
          {/* Card 3: Improved Targeting */}
          <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col">
            <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
              Improved Targeting
            </h3>
            <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-mb-6 tw-flex-grow">
              Use enriched data to create more precise audience segments, enabling more targeted and effective marketing campaigns.
            </p>
            <div className="tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-mt-auto">
              <img
                src={ImprovedTargeting}
                alt="Improved Targeting"
                className="tw-max-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                loading="lazy"
              />
            </div>
          </div>

          {/* Card 4: Increased Accuracy */}
          <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col">
            <h3 className="tw-text-lg tw-font-bold tw-text-slate-800 tw-mb-3">
              Increased Accuracy
            </h3>
            <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-mb-6 tw-flex-grow">
              Reduce errors and ensure that your marketing and sales teams are working with the most accurate and up-to-date information available.
            </p>
            <div className="tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center tw-mt-auto">
              <img
                src={IncreasedAccuracy}
                alt="Increased Accuracy"
                className="tw-max-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                loading="lazy"
              />
            </div>
          </div>

        </div>

        {/* Row 3: Seamless Integration (Full width horizontal layout) */}
        <div className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 sm:tw-p-10 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.01] tw-transition-all tw-duration-300">
          <div className="tw-grid tw-grid-cols-1 lg:tw-grid-cols-12 tw-gap-8 tw-items-center tw-text-left">
            <div className="lg:tw-col-span-5">
              <h3 className="tw-text-xl tw-font-bold tw-text-slate-800 tw-mb-4">
                Seamless Integration
              </h3>
              <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                Easily integrate enriched data into your existing CRM, marketing automation tools, and other business systems for a streamlined workflow.
              </p>
            </div>
            <div className="lg:tw-col-span-7 tw-overflow-hidden tw-rounded-2xl tw-border tw-border-solid tw-border-slate-100 tw-bg-slate-50 tw-flex tw-items-center tw-justify-center">
              <img
                src={SeamlessIntegration}
                alt="Seamless Integration"
                className="tw-max-w-full tw-h-auto tw-object-contain hover:tw-scale-[1.02] tw-transition-transform tw-duration-300"
                loading="lazy"
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default FeatureGrid;
